import { Assets } from "../../../packages/assets.ts"

export const FestivalMap = () => {
  return (
    <section className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h2>Festival map</h2>
      </div>

      <img src={Assets.images.festivalMap} alt="Festival map" />
    </section>
  )
}
